import { jsxs, jsx } from "react/jsx-runtime";
import PropTypes from "prop-types";
import { LegendGroup, LegendHeading, LegendList, LegendNoData } from "./legend.styles.es.js";
import { LegendItem } from "./legend-item.es.js";
const propTypes = {
  heading: PropTypes.string,
  icon: PropTypes.oneOf(["circle", "line"]),
  items: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string,
      icon: PropTypes.node,
      key: PropTypes.string,
      label: PropTypes.string,
      size: PropTypes.oneOf(["small", "medium"]),
      value: PropTypes.string
    })
  ),
  subheading: PropTypes.string
};
const defaultProps = {
  heading: void 0,
  icon: void 0,
  items: [],
  subheading: void 0
};
const Legend = ({ heading, icon, items, subheading, ...restProps }) => /* @__PURE__ */ jsxs(LegendGroup, { ...restProps, children: [
  heading && /* @__PURE__ */ jsx(LegendHeading, { children: heading }),
  subheading && /* @__PURE__ */ jsx(LegendHeading, { subheading: true, children: subheading }),
  items.length ? /* @__PURE__ */ jsx(LegendList, { children: items.map((item, index) => /* @__PURE__ */ jsx(
    LegendItem,
    {
      icon: item.icon || icon && {
        type: icon,
        color: item.color,
        size: item.size
      },
      label: item.label,
      value: item.value
    },
    item.key || index
  )) }) : /* @__PURE__ */ jsx(LegendNoData, {})
] });
Legend.propTypes = propTypes;
Legend.defaultProps = defaultProps;
export {
  Legend
};
